const ASPECT_RATIO = 3 / 2;
const RENDERING_QUEUED_STATES = ['queued', 'idle', 'processing'];
const POLL_RENDERING_IN_STATES = ['rendering', ...RENDERING_QUEUED_STATES];
const POLL_DELAY = 10 * 1000;

export default {
  ASPECT_RATIO,
  POLL_DELAY,
  POLL_RENDERING_IN_STATES,
  RENDERING_QUEUED_STATES,
};
